module.exports = __webpack_public_path__ + "img/Tessellate17.6a9cb508.jpg";